import { postJobApiCall } from './jobRequest';

/**
 * @typedef {'started' | 'completed' | 'abandoned'} TrackStatus
 *
 * @typedef {Object} TrackJobFlowStepParams
 * @property {string}      flowSessionId - Unique session identifier for the wizard flow
 * @property {string}      stepId        - Machine-readable step identifier
 * @property {string}      stepLabel     - Human-readable step label
 * @property {TrackStatus} status        - Current step status
 * @property {string|null} [jobId]       - Job ID (null for early steps before job is created)
 * @property {number}      [elapsed_ms]  - Time spent on this step in milliseconds
 *                                         (sent inside the `extra` field per API spec)
 */

/**
 * Fire-and-forget tracking call for job-creation wizard steps.
 * Designed to never throw — tracking must never break the UI.
 *
 * @param {TrackJobFlowStepParams} params
 * @returns {Promise<void>}
 */
export const trackJobFlowStep = async ({
    flowSessionId,
    stepId,
    stepLabel,
    status,
    jobId = null,
    elapsed_ms = 0,
}) => {
    if (!flowSessionId) return;

    try {
        await postJobApiCall('job-flow/track', {
            flow_session_id: flowSessionId,
            step_id: stepId,
            step_label: stepLabel,
            status,
            job_id: jobId,
            extra: {
                url: window.location.href,
                device: 'web',
                elapsed_ms,
            },
        });
    } catch {
        // Silently swallow — tracking must never interrupt the UI
    }
};
